import { CACHE_TIERS } from "@workspace/types";
import { trpc } from "@/lib/trpc/react";

/**
 * Hook for fetching show facepile data separately from main content
 * Uses DYNAMIC tier for efficient caching with 30s freshness
 * Combined with invalidation on mutations for instant updates
 */
export function useShowFacepile(
	showIds: string[],
	options?: {
		enabled?: boolean;
	},
): ReturnType<typeof trpc.show.getFacepileData.useQuery> {
	return trpc.show.getFacepileData.useQuery(
		{ showIds },
		{
			...CACHE_TIERS.DYNAMIC, // 30s cache for social data
			enabled: (options?.enabled ?? true) && showIds.length > 0,
			refetchOnMount: true, // Fetch fresh data on navigation (mutations invalidate cache)
			refetchOnWindowFocus: false, // Prevent rate limit spikes on tab switching
		},
	);
}